module.exports = __webpack_public_path__ + "img/career-no-open-position.58c0598f.svg";